module.exports = __webpack_public_path__ + "img/marketing-team-directory.290db7fc.png";